import request from './axiosFun';

var url = ''
var img = ''
if (process.env.NODE_ENV === "development") {
  url = '/est'
  img = '/img'
} else {
  url = ''
  img = ''
}
export function listApi(data) {
  return request({
    url: url + '/pasture/cameraDevicePc/getDsList',
    method: 'post',
    data,
    notoken: 'old'
  })
}
export function listApiF(data) {
  return request({
    url: url + '/pasture/cameraDevicePc/getUserDsList',
    method: 'post',
    data,
    notoken: 'old'
  })
}
// 上传图片
export function uploadFile(data, type) {
  return request({
    url: img + '/files/filesUpload/uploadImage',
    method: 'post',
    data,
    headers: {
      Active: type
    },
    notoken: 'old'
  })
}
// 认证
export function autoInfo(data) {
  return request({
    url: url + '/pasture/userInfo/getUserAuthInfo',
    method: 'post',
    data,
  })
}
// 修改昵称

export function editNameApi(data) {
  return request({
    url: url + '/pasture/userInfo/updateUserInfo',
    method: 'post',
    data,
  })
}
// 添加设备

export function addCameraDevice(data) {
  return request({
    url: url + '/pasture/cameraDevicePc/addCameraDevice',
    method: 'post',
    data,
  })
}
export function detailApi(data) {
  return request({
    url: url + '/pasture/cameraDevice/dsView',
    method: 'post',
    data,
    notoken: 'old'
  })
}
// 发送验证码

export function sendCodeApi(data) {
  return request({
    url: url + '/base-server/aliOperate/smsCode',
    method: 'post',
    data,
  })
}
// 修改密码

export function editPwdApi(data) {
  return request({
    url: url + '/pasture/userInfo/forgotPwd',
    method: 'post',
    data,
  })
}
// 注册

export function registerApi(data) {
  return request({
    url: url + '/pasture/userInfo/register',
    method: 'post',
    data,
    notoken: 'old'
  })
}
// 验证码登录
export function accountSmsLoginApi(data) {
  return request({
    url: url + '/pasture/userInfo/accountSmsLogin',
    method: 'post',
    data,
    notoken: 'old'
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js